// extracted by mini-css-extract-plugin
export var container = "_a2-0";